export default __webpack_public_path__ + "static/media/art-pro-brw-poster-2.3f2daba1.jpg";